import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    root: {
        width: "90vw",
        maxWidth: "360px",
        margin: "0 20px 0 auto",
    },
    rootMobile: {
        width: "100%",
        margin: "0 20px 0 auto",
    },
    button: {
        width: "100%",
    },
    heading: {
        fontSize: theme.typography.pxToRem(24),
        fontWeight: theme.typography.fontWeightMedium,
    },
    more: {
        marginRight: "4px",
        backgroundColor: "#3BBDE3",
        height: "28px",
        width: "35px",
        padding: "3px",
        "&:hover": {
            backgroundColor: "#81EEFA",
        },
    },
    less: {
        backgroundColor: "#FC2A3A",
        height: "28px",
        width: "35px",
        padding: "3px",
        "&:hover": {
            backgroundColor: "#FC6470",
        },
    },
    scroll: {
        width: "100%",
        paddingRight: "10px",
        height: "200px",
        overflow: "auto",
        overflowX: "hidden",
    },
    grid: {
        paddingRight: "10px",
        alignItems: "center",
        margin: "3px",
    },
    inner: {
        display: "flex",
        position: "relative",
        width: "100%",
        minHeight: "30px",
        overflow: "hidden",
        border: "2px solid #313131",
    },
    leftSection: {
        width: "50%",
        display: "flex",
        flexDirection: "row-reverse",
    },
    rightSection: {
        width: "50%",
    },
    down: {
        width: "50%",
        backgroundColor: "#FC2A3A",
        height: "100%",
    },
    up: {
        width: "50%",
        backgroundColor: "#3BBDE3",
        height: "100%",
    },
    charContainer: {
        position: "absolute",
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
    },
    characteristics: {
        fontSize: "18px",
        fontWeight: "700",
        textAlign: "center",
        fontFamily: "'Bebas Neue', cursive",
        "@media (max-width: 378px)": {
            fontSize: "16px",
        },
    },
    iconMountaon: {
        width: "9vw",
        height: "9vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#313131",
        borderTopRightRadius: "4px",
        borderBottomRightRadius: "4px",
    },
    openMountainIcon: {
        width: "9vw",
        height: "9vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#313131",
        borderTopLeftRadius: "4px",
        borderBottomLeftRadius: "4px",
    },
    white: {
        color: "white",
    },
    left: {
        position: "relative",
        left: "6px",
    },
}));
